import { WebSocketSendRequestDataMessage } from './web-socket-send-request-data-message';

/**
 * {
 *     "action": "DATA_REQUEST",
 *     "entityId": 420420,
 *     "payload": {
 *         "locationId": 420420,
 *         "requestId": "aaaaaaaa-1111-2222-333-999999999999",
 *         "dataType": "WebsocketDataRequestType_Menu",
 *         "metadata": {
 *             "MenuId": "90515669-bcb2-491c-9e63-96b35f67f964",
 *             "Source": "Display"
 *         }
 *     }
 * }
 */
export class WebSocketRequestMenu extends WebSocketSendRequestDataMessage {
  constructor(locationId: number, menuId: string) {
    super();
    this.payload.locationId = locationId;
    this.payload.dataType = 'WebsocketDataRequestType_Menu';
    this.payload.metadata = {
      MenuId: menuId,
      Source: 'Display'
    };
  }
}
